import { BehaviorSubject, debounceTime, Subject } from "rxjs";
import { inject, singleton } from "tsyringe";
import { ExtensionContext } from "../../common/models/extension-config";
import { Module } from "../../common/module";
import { ApiModule } from "../common/api/api.module";
import { ChangeRoleInfoRequestDTO, ChangeRoleResponseDTO, SiteRoleType, ChangeRoleRequestDTO } from "../common/api/autogenerated";
import { RequestInterceptorModule } from "../common/request-interceptor.module";
import { UiModule } from "../common/ui.module";
import ChangeRolePopup from './ChangeRolePopup.vue';
@singleton()
export class ChangeRoleCommonModule extends Module {
    public name: string = 'ChangeRoleCommonModule';
    public acceptedLicenseFlags: string[] = ['ChangeRole', 'NetflixIntegrations'];
    public shouldRun(context: ExtensionContext): boolean {
        // this does not run on its own - it is called by either button module
        return false;
    }

    constructor(
        @inject(ApiModule) private apiModule: ApiModule,
        @inject(RequestInterceptorModule) private requestInterceptor: RequestInterceptorModule,
        @inject(UiModule) private uiModule: UiModule) {
        super([apiModule, requestInterceptor, uiModule]);
    }

    public configEvent = new BehaviorSubject<ChangeRoleResponseDTO | undefined>(undefined);

    private readonly configRequest = new Subject<void>();
    public async run(): Promise<void> {

        this.configRequest.pipe(debounceTime(1000)).subscribe(e => this.getConfig());
        this.configRequest.next();
        let hasGetSessionInfoTriggered = false;
        this.requestInterceptor.onTableauRequest.subscribe(request => {
            if (!request.dataObject) {
                return;
            }
            if (request.dataObject.method == 'switchSite' ||
                request.dataObject.method == 'login' ||
                (request.dataObject.method == 'getSessionInfo' && !hasGetSessionInfoTriggered)) {
                hasGetSessionInfoTriggered = true;
                request.request.addEventListener('load', () => {
                    if (request.request.status === 200) {
                        const resJson = JSON.parse(request.request.responseText);
                        if (resJson?.result) {
                            setTimeout(() => this.configRequest.next(), 300);
                        }
                    }
                }, false);
            }
        })
    }

    private async getConfig() {
       
        const api = await this.apiModule.apiRequest(c => {
            const requestModel = new ChangeRoleInfoRequestDTO({
                serverId: window.stm.config.serverId
            });
            if (window.stm.config.licenseFlags.includes('NetflixIntegrations')) {
                return c.apiCustomNxTableauIntegrationGetRoles(requestModel);
            } else {
                return  c.apiChangeRoleTableauIntegrationGetAvailableRoles(requestModel);
            }

        });
        if (!api.success) {
            this.log.e('Failed to request available Tableau Server roles');
            return;
        }
        this.configEvent.next(api.value)
    }

    private dialogId = 'stm-changerole-dialog';
    public async showDialog() {
        const config = this.configEvent.value;
        if (!config) {
            return;
        }
        this.uiModule.injectUI(ChangeRolePopup, undefined, {
            info: config!
        });
        return;

    }

}